/**
 * Storefront-only money label fallback for dynamic/AJAX price text.
 * Arabic: 1.200 د.ك | English: KD 1.200 — pad to 3 decimals (string only).
 * Never runs on Shopify checkout / order-summary / payment DOM.
 */
(function () {
  var AR_SUFFIX = ' د.ك';
  var EN_PREFIX = 'KD ';
  var AMOUNT_CORE = '[\\d][\\d,]*(?:\\.\\d{1,3})?';

  var CHECKOUT_ZONE_SELECTOR = [
    '#checkout',
    '#shopify-checkout',
    '.shopify-checkout',
    '[data-shopify="checkout"]',
    '[data-shopify-checkout]',
    'shopify-checkout',
    '.order-summary',
    '#order-summary',
    '.order-summary__section',
    '.content-box--order-summary',
    '.icartShopifyCartContent',
    '[class*="icart"]',
    '[id*="icart"]'
  ].join(', ');

  function isCheckoutPage() {
    var host = (window.location.hostname || '').toLowerCase();
    if (host === 'checkout.shopify.com' || host.indexOf('.checkout.shopify.com') !== -1) {
      return true;
    }
    var path = window.location.pathname || '';
    if (/^\/checkouts?\//.test(path)) {
      return true;
    }
    var body = document.body;
    if (!body) {
      return false;
    }
    if (body.classList.contains('template-checkout')) {
      return true;
    }
    if (document.querySelector('shopify-checkout, #checkout.shopify-checkout')) {
      return true;
    }
    return false;
  }

  function isArabicLocale() {
    var html = document.documentElement;
    return (html.lang && html.lang.indexOf('ar') === 0) || html.getAttribute('dir') === 'rtl';
  }

  function hasDualCurrency(str) {
    return /د\.ك/.test(str) && /\b(?:KD|KWD)\b/i.test(str);
  }

  /** Pad fractional part to 3 digits; does not parse or round the numeric value. */
  function ensureThreeDecimals(amountStr) {
    if (!amountStr || typeof amountStr !== 'string') return amountStr;
    var s = amountStr.replace(/,/g, '').trim();
    var dot = s.indexOf('.');
    var whole;
    var frac;

    if (dot === -1) {
      whole = s;
      frac = '';
    } else {
      whole = s.slice(0, dot);
      frac = s.slice(dot + 1);
    }

    while (frac.length < 3) {
      frac = frac + '0';
    }

    return whole + '.' + frac;
  }

  function formatAmountToken(token) {
    return ensureThreeDecimals(token);
  }

  function rewriteMoneyString(str) {
    if (!str || typeof str !== 'string') return str;
    var s = str.replace(/\u00a0/g, ' ').trim();
    if (hasDualCurrency(s)) {
      return str;
    }
    var m;
    var lead = '';
    if (s.charAt(0) === '-') {
      lead = '-';
      s = s.slice(1).trim();
    }

    if (hasDualCurrency(s)) {
      return lead + s;
    }

    if (isArabicLocale()) {
      m = s.match(new RegExp('^(?:KD|KWD)\\s*(' + AMOUNT_CORE + ')$', 'i'));
      if (m) return lead + formatAmountToken(m[1]) + AR_SUFFIX;
      m = s.match(new RegExp('^(' + AMOUNT_CORE + ')\\s*(?:KD|KWD)$', 'i'));
      if (m) return lead + formatAmountToken(m[1]) + AR_SUFFIX;
      m = s.match(new RegExp('^(' + AMOUNT_CORE + ')\\s*د\\.ك$'));
      if (m) return lead + formatAmountToken(m[1]) + AR_SUFFIX;
      return lead ? lead + s : str;
    }

    m = s.match(new RegExp('^(' + AMOUNT_CORE + ')\\s*د\\.ك$'));
    if (m) return lead + EN_PREFIX + formatAmountToken(m[1]);
    m = s.match(new RegExp('^د\\.ك\\s*(' + AMOUNT_CORE + ')$'));
    if (m) return lead + EN_PREFIX + formatAmountToken(m[1]);
    m = s.match(new RegExp('^(?:KD|KWD)\\s*(' + AMOUNT_CORE + ')$', 'i'));
    if (m) return lead + EN_PREFIX + formatAmountToken(m[1]);

    return lead ? lead + s : str;
  }

  function shouldSkipNode(node) {
    if (!node || node.nodeType !== 1) return true;
    if (isCheckoutPage()) return true;
    if (node.closest(CHECKOUT_ZONE_SELECTOR)) return true;
    if (node.closest('script[type="application/ld+json"]')) return true;
    if (node.closest('.shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"]')) {
      return true;
    }
    return false;
  }

  function rewriteElement(el) {
    if (shouldSkipNode(el)) return;

    if (el.classList && el.classList.contains('sinbad-money__amount')) {
      var raw = el.textContent;
      if (raw && raw.trim()) {
        var padded = formatAmountToken(raw.trim());
        if (padded !== raw.trim()) el.textContent = padded;
      }
      return;
    }

    if (el.querySelector('.sinbad-money')) return;

    el.childNodes.forEach(function (node) {
      if (node.nodeType === 3) {
        var text = node.textContent;
        if (!text || !text.trim()) return;
        var next = rewriteMoneyString(text);
        if (next !== text) node.textContent = next;
      }
    });
  }

  var TARGET_SELECTORS = [
    '[data-header-cart-total]',
    '[data-cart-total]',
    '.sinbad-basket-total',
    '#SinbadProgressText',
    '.product-price',
    '.cart-item__price',
    '.search-results-container .cart-item__price .price',
    '.sticky-add-to-cart__price',
    '[class*="ai-flash-deals-product-price-"]',
    'shipping-notice',
    '.cart__discount-code-amount',
    '.flash-deals-progress__message',
    '.sinbad-money__amount'
  ];

  function apply(root) {
    if (isCheckoutPage()) return;
    root = root || document.body;
    if (!root || !root.querySelectorAll) return;
    TARGET_SELECTORS.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        if (el.closest(CHECKOUT_ZONE_SELECTOR)) return;
        rewriteElement(el);
      });
    });
  }

  function init() {
    if (isCheckoutPage()) return;
    apply(document);
    document.addEventListener('cart-updated', function () {
      apply(document);
    });
    document.addEventListener('krown:cart:update', function () {
      apply(document);
    });
    document.addEventListener('variant:change', function () {
      apply(document);
    });
    document.addEventListener('flash-deals:state-updated', function () {
      apply(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SinbadMoneyDisplay = {
    apply: apply,
    rewriteMoneyString: rewriteMoneyString,
    ensureThreeDecimals: ensureThreeDecimals,
    isArabicLocale: isArabicLocale,
    isCheckoutPage: isCheckoutPage
  };
})();
